import { TOKEN_NAMES } from "../config";

export const getMintAddressFromPath = fieldPath => fieldPath.split?.(".")[0];

export const getTokenNameFromMint = mintAddress => {
  if (!mintAddress || mintAddress === "sol") return "Sol";

  return TOKEN_NAMES[mintAddress] || "Unknown Token";
};
